<template>
  <div class="redPacketRecord">
    <!-- 选择区 -->
    <div class="search_box">
      <span class="title">用户openid/appid/商户id</span>
      <el-input v-model="parameter.keywords" style="width:200px" placeholder="openid/appid/id" />
      <span class="title">状态</span>
      <el-select v-model="parameter.status" placeholder="请选择状态">
        <el-option
          v-for="item in status_s"
          :key="item.id"
          :label="item.value"
          :value="item.id"
        />
      </el-select>
      <span class="title">发放时间</span>
      <el-date-picker
        v-model="parameter.date"
        format="yyyy-MM-dd"
        value-format="yyyy-MM-dd"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
      />
      <!-- <div class="item">
        <span class="title">商户id</span>
        <el-input v-model="parameter.merchant_id" style="width:200px" placeholder="请输入商户id" />
      </div> -->
      <span class="title">红包商户单号</span>
      <el-input v-model="parameter.mch_bill_no" style="width:200px" placeholder="红包商户单号" />
      <el-button icon="el-icon-search" type="primary" style="max-height:37px" @click="(parameter.page = 1),(getData())">搜索</el-button>
      <el-button icon="el-icon-refresh-left" type="info" style="max-height:37px" @click="reset">重置</el-button>
    </div>

    <!-- 主体区 -->
    <div>
      <el-table
        v-loading="loading"
        :data="tableData"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="open_id"
          label="openid"
          width="240"
          align="center"
        />
        <el-table-column
          prop="act_name"
          label="活动名字"
          width="180"
          align="center"
        />
        <el-table-column
          prop="total_amount"
          label="红包金额"
          width="80"
          align="center"
        />
        <el-table-column
          prop="merchant_id"
          label="商户id"
          width="150"
          align="center"
        />
        <el-table-column
          prop="send_list_id"
          label="红包微信支付id"
          width="180"
          align="center"
        />
        <el-table-column
          prop="sendTimeText"
          label="发送时间"
          width="180"
          align="center"
        />
        <el-table-column
          prop="statusText"
          label="发送状态"
          width="180"
          align="center"
        >
          <template slot-scope="scope">
            <i v-if="scope.row.status == 1" class="el-icon-warning" />
            <i v-if="scope.row.status == 2" class="el-icon-more-outline defaultrse" />
            <i v-if="scope.row.status == 3" class="el-icon-success defaultrse" />
            <i v-if="scope.row.status == 4" class="el-icon-success stopew" />
            <i v-if="scope.row.status == 5" class="el-icon-success defaultr" />
            <i v-if="scope.row.status == 6" class="el-icon-more-outline stopew" />
            <i v-if="scope.row.status == 7" class="el-icon-more-outline defaultr" />
            {{ scope.row.statusText }}
          </template>
        </el-table-column>
        <el-table-column
          prop="mch_bill_no"
          label="红包商户编号"
          width="250"
          align="center"
        />
        <el-table-column
          prop="statusText"
          label="操作"
          align="center"
        >
          <template slot-scope="scope">
            <el-button type="warning" size="mini" @click="editinfo(scope.row)">详情</el-button>
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="app_id"
          label="公众号appId"
          width="180"
          align="center"
        />

        <el-table-column
          prop="mch_bill_no"
          label="红包商户编号"
          width="180"
          align="center"
        />
        <el-table-column
          prop="wishing"
          label="祝福语"
          width="180"
          align="center"
        />

        <el-table-column
          prop="err_code_des"
          label="错误信息"
          width="180"
          align="center"
        />

        <el-table-column
          prop="refundTimeText"
          label="退款时间"
          width="180"
          align="center"
        />
        <el-table-column
          prop="detail_id"
          label="红包id"
          width="180"
          align="center"
        />
        <el-table-column
          prop="rcvTimeText"
          label="领取时间"
          width="180"
          align="center"
        />
        <el-table-column
          prop="remark"
          label="备注信息"
          width="180"
          align="center"
        />
        <el-table-column
          prop="refund_amount"
          label="退款金额"
          width="180"
          align="center"
        />
        <el-table-column
          prop="createdAtText"
          label="创建时间"
          width="180"
          align="center"
        /> -->

      </el-table>
      <el-dialog
        title="详情信息"
        :visible.sync="dialogVisiblesdew"
        width="30%"
      >
        <div>
          <div style="margin-bottom:10px">openid:{{ obj.open_id }}</div>
          <div style="margin-bottom:10px">活动名字:{{ obj.act_name }}</div>
          <div style="margin-bottom:10px">红包金额:{{ obj.total_amount }}元</div>
          <div style="margin-bottom:10px">商户id:{{ obj.merchant_id }}</div>
          <div style="margin-bottom:10px">红包微信支付id:{{ obj.send_list_id }}</div>
          <div style="margin-bottom:10px">发送时间:{{ obj.sendTimeText }}</div>
          <div style="margin-bottom:10px">发送状态:{{ obj.statusText }}</div>
          <div style="margin-bottom:10px">红包商户编号:{{ obj.mch_bill_no }}</div>
          <div style="margin-bottom:10px">公众号appId:{{ obj.app_id }}</div>
          <div style="margin-bottom:10px">祝福语:{{ obj.wishing }}</div>
          <div style="margin-bottom:10px">错误信息:{{ obj.err_code_des }}</div>
          <div style="margin-bottom:10px">退款时间:{{ obj.refundTimeText }}</div>
          <div style="margin-bottom:10px">红包id:{{ obj.detail_id }}</div>
          <div style="margin-bottom:10px">领取时间:{{ obj.rcvTimeText }}</div>
          <div style="margin-bottom:10px">备注信息:{{ obj.remark }}</div>
          <div style="margin-bottom:10px">退款金额:{{ obj.refund_amount }}</div>
          <div style="margin-bottom:10px">创建时间:{{ obj.createdAtText }}</div>
        </div>
      </el-dialog>
    </div>
    <PaginationRight
      :total="total"
      @size-change="fetchPageSizeone"
      @current-change="fetchCurrentPageone"
    />
  </div>
</template>

<script>
import { redPacketRecord } from '@/api/weChatMerchants.js'
import PaginationRight from '@/components/PaginationRight'
export default {
  name: 'RedPacketRecord',
  components: {
    PaginationRight
  },
  data() {
    return {
      parameter: {
        page: 1, // 页码
        pageSize: 10, // 页数
        keywords: null, // 用户openid
        status: 0, // 0 默认全部 1 生成记录待发出 2 发放中 3 已发放待领取 4 发放失败 5 已领取 6 退款中 7 已退款
        date: [], // 时间
        // merchant_id: null, // 	商户id
        mch_bill_no: null // 红包商户单号
      },
      status_s: [{ id: 0, value: '全部' }, { id: 1, value: '生成记录待发出' }, { id: 2, value: '发放中' }, { id: 3, value: '已发放待领取' }, { id: 4, value: '发放失败' }, { id: 5, value: '已领取' }, { id: 6, value: '退款中' }, { id: 7, value: '已退款' }],
      tableData: [],
      total: null,
      loading: false,
      dialogVisiblesdew: false,
      obj: {}
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      this.loading = true
      const data = await redPacketRecord({ ...this.parameter, send_date_start: this.parameter.date && this.parameter.date[0], send_date_end: this.parameter.date && this.parameter.date[1] })
      this.tableData = data.data.list
      this.total = data.data.total
      this.loading = false
    },
    fetchPageSizeone(e) {
      this.parameter.pageSize = e
      this.getData()
    },
    fetchCurrentPageone(e) {
      this.parameter.page = e
      this.getData()
    },
    reset() {
      this.parameter = {
        page: 1, // 页码
        pageSize: 10, // 页数
        keywords: null, // 用户openid
        status: 0, // 0 默认全部 1 生成记录待发出 2 发放中 3 已发放待领取 4 发放失败 5 已领取 6 退款中 7 已退款
        date: [], // 时间
        // merchant_id: null, // 	商户id
        mch_bill_no: null // 红包商户单号
      }
      this.getData()
    },
    editinfo(item) {
      this.dialogVisiblesdew = true
      this.obj = item
    }
  }
}
</script>

<style>
.redPacketRecord{
  width: 95%;
  margin: 0 auto;
  margin-top: 50px;
}

.selectionArea{
  margin-bottom: 20px;
  display: flex;
  flex-wrap: wrap;
}

.title{
  display: inline-block;
  margin-right: 10px;
  font-size: 14px;
  color: #0f0f0f;
}
.defaultrse{
  color: #E6A23C;
}
.defaultr{
  color: #67C23A;
}
.stopew{
  color: red;
}
.fasrw{
  color: #409EFF;
}
.search_box{
  margin-bottom:20px;
}
@media (max-width: 768px){
  .title{
    font-size:3vw;
  }
}
</style>
